import { LEASE_COIN_COST_UNIT_OF_MEASURES } from '../../../constants/rentDetailsConfig';

export const getModemOptions = (modems) =>
  modems?.map(({ modem }) => {
    const { serialNumber, id } = modem || {};
    return {
      text: serialNumber?.trim(),
      value: id,
    };
  });

export const formatCoinCost = (value, uom) => {
  if (value === null || value === undefined || value === '') return '';
  if (uom === LEASE_COIN_COST_UNIT_OF_MEASURES.PERCENTAGE) return `${value}%`;
  return `$${value}`;
};

export const coinCostUomLabel = (uom) =>
  uom === LEASE_COIN_COST_UNIT_OF_MEASURES.PERCENTAGE ? 'Percentage' : 'Dollar';
